/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TreeView from "@mui/lab/TreeView";
import TreeItem, { treeItemClasses, useTreeItem } from "@mui/lab/TreeItem";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Typography, Checkbox, FormControlLabel } from "@common-ui/ui";
import { v4 as uuid } from "uuid";

const ControlledTreeItem = React.forwardRef(function ControlledTreeItem(
  props,
  ref
) {
  const {
    classes,
    className,
    label,
    nodeId,
    icon: iconProp,
    expansionIcon,
    displayIcon,
  } = props;

  const {
    disabled,
    expanded,
    selected,
    focused,
    handleExpansion,
    handleSelection,
    preventSelection,
  } = useTreeItem(nodeId);

  const icon = iconProp || expansionIcon || displayIcon;

  const handleMouseDown = (event) => {
    preventSelection(event);
  };

  const handleExpansionClick = (event) => {
    handleExpansion(event);
  };

  const handleSelectionClick = (event) => {
    handleSelection(event);
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={clsx(className, classes.root, {
        [classes.expanded]: expanded,
        [classes.selected]: selected,
        [classes.focused]: focused,
        [classes.disabled]: disabled,
      })}
      onMouseDown={handleMouseDown}
      ref={ref}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div onClick={handleExpansionClick} className={classes.iconContainer}>
        {icon}
      </div>
      <Typography
        onClick={handleSelectionClick}
        component="div"
        className={classes.label}
      >
        {label}
      </Typography>
    </div>
  );
});

const CustomTreeItem = (props) => (
  <TreeItem ContentComponent={ControlledTreeItem} {...props} />
);

export const PlacesTreeView = ({
  handleAddSubOrg,
  refresh,
  orgId,
  customerId,
  handleAddSubPlace,
  data,
  setPlaces,
  places,
  placesParent,
  setPlacesParent,
}) => {
  // const [expanded, setExpanded] = useState([]);
  const [selected, setSelected] = useState(places || []);
  const [parentMap, setParentMap] = useState(null);

  useEffect(() => {
    setPlaces(selected);
    // if (!selected.length) {
    //   setPlacesParent(undefined);
    // } else {
    //   if (!placesParent && selected[0]) {
    //     function getParent(nodes, parent = undefined) {
    //       if (!nodes.child_places) return;
    //       if (!nodes.child_places.length) return;
    //       if (nodes.system_id === selected[0]) {
    //         setPlacesParent(parent);
    //         return;
    //       }
    //       const newNodes = nodes.child_places;
    //       getParent(newNodes, parent);
    //     }
    //     for (let i = 0; i < data.length; i++) {
    //       getParent(data[i], data[i]);
    //     }
    //   }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(selected)]);

  const StyledTreeItem = styled(CustomTreeItem)(({ theme }) => ({
    color: theme.palette.text.secondary,
    [`& .${treeItemClasses.content}`]: {
      boxSizing: "border-box",
    },
  }));

  const renderOrg = (org) => {
    return org?.screen_name && String(org?.screen_name).trim() !== ""
      ? org?.screen_name
      : org?.name;
  };

  const selectedSet = React.useMemo(() => {
    try {
      if (!selected.length) {
        setPlacesParent(undefined);
      }
      if (!placesParent && selected[0]) {
        function getParent(nodes, parent = undefined) {
          if (!nodes.child_places) return;
          if (!nodes.child_places.length) return;
          if (nodes.system_id === selected[0]) {
            setPlacesParent(parent);
            return;
          }
          const newNodes = nodes.child_places;
          getParent(newNodes, parent);
        }
        for (let i = 0; i < data.length; i++) {
          getParent(data[i], data[i]);
        }
      }
    } catch (error) {
      console.log(error);
    }
    return new Set(selected);
  }, [selected]);
  useEffect(() => {
    let active = true;
    load();
    return () => {
      active = false;
    };
    async function load() {
      async function loadData() {
        let result = {};
        return new Promise((resolve, reject) => {
          for (let i = 0; i < data.length; i++) {
            const newData = goThroughAllNodes(data[i]);
            result = { ...result, ...newData };
          }
          resolve(result);
        });
      }
      const newParentMap = await loadData();
      if (!active) {
        return;
      }
      setParentMap(newParentMap);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  function goThroughAllNodes(nodes, map = {}) {
    if (!nodes.child_places) {
      return null;
    }
    if (!nodes.child_places.length) {
      return null;
    }

    map[nodes.system_id] = getAllChild(nodes).splice(1);

    for (let childNode of nodes.child_places) {
      goThroughAllNodes(childNode, map);
    }
    return map;
  }

  function getAllChild(childNode, collectedNodes = []) {
    if (childNode === null) return collectedNodes;

    collectedNodes.push(childNode.system_id);

    if (Array.isArray(childNode.child_places)) {
      for (const node of childNode.child_places) {
        getAllChild(node, collectedNodes);
      }
    }

    return collectedNodes;
  }

  const getChildById = (nodes, id) => {
    let array = [];
    let path = [];
    function getNodeById(node, id, parentsPath) {
      let result = null;

      if (node.system_id === id) {
        return node;
      } else if (Array.isArray(node.child_places)) {
        for (let childNode of node.child_places) {
          result = getNodeById(childNode, id, parentsPath);

          if (!!result) {
            parentsPath.push(node.system_id);
            return result;
          }
        }

        return result;
      }

      return result;
    }

    const nodeToToggle = getNodeById(nodes, id, path);

    return { childNodesToToggle: getAllChild(nodeToToggle, array), path };
  };

  async function getOnChange(checked, nodes, parentId) {
    setPlacesParent(data.find((item) => item.system_id === parentId));
    const path = [];
    const childNodesToToggle = [];
    for (let newNodes of data) {
      const response = getChildById(newNodes, nodes.system_id);
      path.push(...response.path);
      childNodesToToggle.push(...response.childNodesToToggle);
    }

    let array = checked
      ? [...selected, ...childNodesToToggle]
      : selected
          .filter((value) => !childNodesToToggle.includes(value))
          .filter((value) => !path.includes(value));
    array = array.filter((v, i) => array.indexOf(v) === i);
    if (!array.length) setPlacesParent(undefined);
    setSelected(array);
  }
  const renderParentNode = (parents) => {
    return parents.map((parent, i) => {
      const disabled = placesParent
        ? String(parent.system_id) !== String(placesParent.system_id)
        : false;

      const allSelectedChildren = parentMap[parent.system_id]?.every(
        (childNodeId) => selectedSet.has(childNodeId)
      );

      const checked =
        selectedSet.has(parent.system_id) || allSelectedChildren || false;

      const indeterminate =
        parentMap[parent.system_id]?.some((childNodeId) =>
          selectedSet.has(childNodeId)
        ) || false;

      if (allSelectedChildren && !selectedSet.has(parent.system_id)) {
        setSelected([...selected, parent.system_id]);
      }
      let keyValue = `${String(parent.system_id)}--${uuid().slice(-6)}`;
      return (
        <StyledTreeItem
          key={keyValue}
          disabled={disabled}
          label={
            <FormControlLabel
              // disabled={disabled}
              key={String(parent.system_id)}
              control={
                <Checkbox
                  disabled={disabled}
                  checked={checked}
                  indeterminate={!checked && indeterminate}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(event) =>
                    getOnChange(
                      event.currentTarget.checked,
                      parent,
                      String(parent.system_id)
                    )
                  }
                />
              }
              label={
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "inherit", flexGrow: 1 }}
                  noWrap
                >
                  {renderOrg(parent)}
                </Typography>
              }
            />
          }
          nodeId={String(parent.system_id)}
        >
          {renderTree(String(parent.system_id), parent.child_places) || null}
        </StyledTreeItem>
      );
    });
  };

  const renderTree = (parentId, nodes) => {
    const disabled = placesParent
      ? String(parentId) !== String(placesParent.system_id)
      : false;

    return Array.isArray(nodes)
      ? nodes.length
        ? nodes.map((node) => {
            const allSelectedChildren = parentMap[node.system_id]?.every(
              (childNodeId) => selectedSet.has(childNodeId)
            );
            const checked =
              selectedSet.has(node.system_id) || allSelectedChildren || false;

            const indeterminate =
              parentMap[node.system_id]?.some((childNodeId) =>
                selectedSet.has(childNodeId)
              ) || false;

            if (allSelectedChildren && !selectedSet.has(node.system_id)) {
              setSelected([...selected, node.system_id]);
            }

            return (
              <StyledTreeItem
                disabled={disabled}
                label={
                  <FormControlLabel
                    // disabled={disabled}
                    key={String(node.system_id)}
                    control={
                      <Checkbox
                        checked={checked}
                        indeterminate={!checked && indeterminate}
                        onClick={(e) => e.stopPropagation()}
                        disabled={disabled}
                        onChange={(event) =>
                          getOnChange(
                            event.currentTarget.checked,
                            node,
                            parentId
                          )
                        }
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "inherit", flexGrow: 1 }}
                        noWrap
                      >
                        {renderOrg(node)}
                      </Typography>
                    }
                  />
                }
                key={String(node.system_id)}
                nodeId={String(node.system_id)}
              >
                {renderTree(parentId, node.child_places)}
              </StyledTreeItem>
            );
          })
        : null
      : null;
  };
  return (
    <>
      {/* <Box sx={{ mb: 1 }}>
        <Button onClick={handleExpandClick}>
          {expanded?.length === 0 ? "Expand all" : "Collapse all"}
        </Button>
        <Button onClick={handleSelectClick}>
          {selected?.length === 0 ? "Select all" : "Unselect all"}
        </Button>
      </Box> */}
      <TreeView
        aria-label="rich object"
        defaultCollapseIcon={<ArrowDropDownIcon />}
        defaultExpandIcon={<ArrowRightIcon />}
        defaultEndIcon={<div style={{ width: 24 }} />}
        sx={{
          // maxHeight: "calc(100vh - 55px)",
          // minHeight: 400,
          flexGrow: 1,
          // maxWidth: 360,
          overflow: "auto",
        }}
        // onNodeSelect={(event, nodeIds) => {
        //   router.push({ search: `?place=${nodeIds}` });
        // }}
      >
        {renderParentNode(data)}
      </TreeView>
    </>
  );
};
